export default "__VITE_ASSET__DvN0yTnF__"